import githubM from "./blogImg/githubM.png";
import medium from "./blogImg/medium.jpg";
import gitVsGithub from "./blogImg/gitVsGithub.jpg";
export const BlogData = [
  {
    id: 1,
    img: githubM,
    title: "Now, upload large file to your Github repository!",
    date: "June 20, 2022",
    author: "Written by Shawn",
    des: "You might encounter the issue below- **fatal: the remote end hung up unexpectedly, Everything up-to-date.For certain reasons could happen this! It may be due to network issues. Might be",
    links:
      "https://medium.com/@shawnniamul58/now-upload-large-file-to-your-github-repository-f92bf37185f7",
    dataAos: "zoom-out-right",
  },
  {
    id: 2,
    img: medium,
    title: "How to run ‘React’ and ‘Express’ at the same time!🤔",
    date: "June 22, 2022",
    author: "Written by Shawn",
    des: "Now run your both front end and backend at the same time😌. To start your both front end server and back end server at the same time follow the step below:",
    links:
      "https://medium.com/@shawnniamul58/thinking-about-your-full-stack-cefadfa86bc",
    dataAos: "zoom-out-down",
  },
  {
    id: 3,
    title: "the major difference Between Git and GitHub!",
    img: gitVsGithub,
    date: "June 30, 2022",
    author: "Written by Shawn",
    des: "Here, I’ll try to introduce Git and GitHub, so let’s get started-GitHub: GitHub is a code hosting platform for collaboration and version control. GitHub lets you (and others) work together on projects.",
    links:
      "https://medium.com/@shawnniamul58/the-major-difference-between-git-and-github-866d66cd951c",
    dataAos: "zoom-out-left",
  },
];
